@import '../../../../node_modules/@cpt/pci/postnl-styles/settings';
@import '../../../../node_modules/@cpt/pci/postnl-styles/05-components/alerts';

//specific overwrites for shadow dom
.pci-alert {
    padding: .5em 1em;
    border-radius: .25em;
}

.pci-alert__text {
    padding-left: 2em;
}
